var Backbone = require("backbone");

export default class devstuff {
	setUpDataForResults (id) {
		 var livingcosts = Backbone.Model.extend({
		 defaults: {
		 selectedType: 'rent',
		 costsRent: 900,
		  costsLoan: 900,
		  costsRunning: 200,
		  calc_costsBuy: 0,
		  calc_ownFunds: 0,
		  calc_parcel: 0,
		  calc_house: 0,
		  calc_side: 0,
		  calc_own: 0,
		  calc_interests: 0,
		  calc_period: 20
		 }
		 });
		 
		 var dailyTrip = Backbone.Model.extend({
			 defaults: {
				 distanceBike: null,
				 xy: [13.991303, 48.156267], 
				 id: "1", 
				 name: "1, Zeileisstraße, Lichtenegg, Wels, Oberösterreich, 4600, Österreich",
				 enhancedByWebService: false,
				 selectedMode: null,
				 id_car: "1",
				 freq: 5,
				 costs_pt: 0,
				 purposetext: ''
					 }
			 });
		 
		 var dailyTrips = Backbone.Collection.extend({
			 model: dailyTrip
			 });
		 
		 
		 var dT = new dailyTrips()
		 
		 
//		 dT.on("remove", function(dt) {
//			  var f = dt.get("feature");
//			  var s = dt.get("layerSource");
//			  s.removeFeature(f);
//			});
		 
		 dT.add(new dailyTrip())
		 
		 var car = Backbone.Model.extend({
	 defaults: {
		 type: null,
		 costs_month: null
	 }
	 });


		var cars = Backbone.Collection.extend({
			 model: car
		});
		
		var defaultCars = new cars();
		
		defaultCars.add([
			{type: "low", costs_month: 300, consumption_costs_per_m: 0.0000529},
			{type: "medium", costs_month: 530, consumption_costs_per_m: 0.00006325},
			{type: "high", costs_month: 690, consumption_costs_per_m: 0.00006555}
			]);
		
		var userCars = new cars();
			
		userCars.add([
			{id: "1", type: "low", costs_month: 300, consumption_costs_per_m: 0.0000529},
			{id: "2", type: "low", costs_month: 300, consumption_costs_per_m: 0.0000529},
			{id: "3", type: "low", costs_month: 300, consumption_costs_per_m: 0.0000529}
			]);
		
		var targetroutes = {"sports_centre":{"length":null,"walktime":null,"type":"Sporteinrichtung","geometry":null,"targetxy":null,"priority":0.28,"targetname":null},
				"pharmacy":{"length":572.5116134915577,"walktime":6.815614446328068,"type":"Apotheke","geometry":[],"targetxy":[13.9953658,48.1465504],"priority":0.14,"targetname":"Föhren-Apotheke"},
				"supermarket":{"length":93.2861449954988,"walktime":1.1105493451845097,"type":"Nahversorger","geometry":[],"targetxy":[13.98834739,48.14873922],"priority":0.6,"targetname":"Eurospar"}
		}
		
		var ptquali = {"quality":"Hoch","nextStation":{"walk_to_station":{"geometry":[[[13.9765290264722,48.209731541395],[13.9761050963796,48.2096589812951],[13.9760346144578,48.2096545961769]],[[13.9760346144578,48.2096545961769],[13.9758713550644,48.2096198120797],[13.9756911101401,48.2095884257531]],[[13.9756911101401,48.2095884257531],[13.9757029724914,48.2095280062149],[13.9757176543294,48.2094830280564],[13.9757218034878,48.2094727033164]]],"station_xy":[13.9754322,48.2094209],"name":"Haiding (OÖ) Bahnhof","walk_time":0.9440622270262501,"walk_distance":79.301227070205},"type":"train_station","frq_data":{"frequency":30,"time":"06:00-09:00"}},"trainStation":{"walk_to_station":{"geometry":[[[13.9765290264722,48.209731541395],[13.9761050963796,48.2096589812951],[13.9760346144578,48.2096545961769]],[[13.9760346144578,48.2096545961769],[13.9758713550644,48.2096198120797],[13.9756911101401,48.2095884257531]],[[13.9756911101401,48.2095884257531],[13.9757029724914,48.2095280062149],[13.9757176543294,48.2094830280564],[13.9757218034878,48.2094727033164]]],"station_xy":[13.9754322,48.2094209],"name":"Haiding (OÖ) Bahnhof","walk_time":0.9440622270262501,"walk_distance":79.301227070205},"type":"train_station","frq_data":{"frequency":30,"time":"06:00-09:00"}}}
		 
		 
		 var livingplace = Backbone.Model.extend({
		 initialize: function () {
		 this.set("livingcosts", new livingcosts());
		 this.set("userCars", userCars);
		 this.set("defaultCars", defaultCars);
		 this.set("targetroutes", targetroutes);
		 this.set("ptquali", ptquali);
		 },
		 defaults: {
		 address: "",
		 xy: [14.02521921371952, 
			 48.161774040497846],
		 targetroutes: null,
		 lastinframapextent:null,
		 name: "Bla",
		 dailyTrips: dT
		 }
		 });
		 
		 var livingplaces = Backbone.Collection.extend({
			 model: dailyTrip
			 });
		 
		 var livingplaces = Backbone.Collection.extend({
		 model: livingplace
		 });
		 var coll = new livingplaces();
         var lp1 = new livingplace();
         var lp2 = new livingplace();
         lp1.set("id", "1");
         lp2.set("id", "2");
		 coll.add([lp1, lp2])
		 window.datastore.lps = coll
	}
	
}



// WEBPACK FOOTER //
// ./src/models/dev.js